export function constructUrl(baseUrl: string, path: string): string {
  return baseUrl + path;
}

export function validateAndFilterAddresses(inputRanges: string[]) {
  return inputRanges
    ? inputRanges.filter((address) => {
        const excelAddressPattern = /^(?:[a-zA-Z0-9_]+!)?[A-Z]+[0-9]+(?::[A-Z]+[0-9]+)?$/;
        return excelAddressPattern.test(address);
      })
    : [];
}

export function standardizeDecimalSeparator(value: any, parameterType?: string): any {
  if (Array.isArray(value)) {
    return value.map((item) => standardizeDecimalSeparator(item, parameterType));
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();

    if (trimmedValue === "") return undefined;
    if (parameterType === "string") return value;

    const commaDecimalPattern = /^-?[\d\s]+,\d+$/;
    const europeFormatPattern = /^-?(\d{1,3}(\.\d{3})+),\d+$/;
    const plainNumberPattern = /^-?\d+(\.\d+)?$/;

    if (commaDecimalPattern.test(trimmedValue)) {
      return parseFloat(trimmedValue.replace(",", "."));
    } else if (europeFormatPattern.test(trimmedValue)) {
      return parseFloat(trimmedValue.replace(/\./g, "").replace(",", "."));
    } else if (plainNumberPattern.test(trimmedValue)) {
      return parseFloat(trimmedValue);
    }
  }

  return value;
}
